module.exports = __webpack_public_path__ + "img/IMG_8673_L_Foamcore_MockedUp.2e0dd3aa.jpg";